// import React from 'react';
// import { Link } from 'react-router-dom';
import './style.css';
// Import images
import AboutImg from '../../../assets/img/banner/WhatsApp Image 2025-06-23 at 16.49.33_f42f2d8a.jpg';


const Many = () => {
    return (
        <section className="who_we_are_section section_padding" style={{ backgroundColor: '#F8E9ED' }}> 
            <div className="container">
                <div className="row align-items-center who-we-are-row">
                    <div className="col-lg-6 col-md-12 who_we_are_text_col order-2 order-lg-1">
                        <div className="about_area_main_text">

                            <br />
                            <br />
                            <h2 className="who_we_are_heading">Why We Help</h2>
                            <div className="who_we_are_subheading">Walking the Path Alone </div>
                            <p className="who_we_are_paragraph">
                                Many pregnant women—especially vulnerable young adults and single mothers—face
                                overwhelming emotions and difficult choices. Social stigma, financial hardship, and emotional
                                distress can lead to thoughts of abortion or abandonment of their babies.
                                <br />
                                <br />
                                <strong>But no mother should have to walk this path alone</strong>
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-12 who_we_are_img_col order-1 order-lg-2">
                        <div className="who_we_are_img">
                            <img
                                src={AboutImg}
                                alt="Cradle Care Foundation"
                                className="img-fluid"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Many;
